import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let inflight = null;

/** Work-order types, statuses, transitions, priorities and inspection vocabulary from the server. */
export function useWorkMeta() {
  const [meta, setMeta] = useState(cache);

  useEffect(() => {
    if (cache) return;
    if (!inflight) inflight = api.get("/work-orders/meta").then(({ data }) => (cache = data));
    inflight.then((data) => setMeta(data)).catch(() => setMeta(null));
  }, []);

  return meta;
}

export const typeLabel = (meta, value) =>
  meta?.work_types?.find((t) => t.value === value)?.label || value || "Work";
